/**
 * RESPONSIBILITY: draw a band that says where somebody is going — an address and a way to get there.
 *
 * An <address>, because it is one. The map link opens in a new tab like every other map
 * link on the site (see map-link.ts), and the words under the address are optional - parking,
 * which door - for what the address alone does not say.
 */
import { Html } from '@framework/react';
import { mapTarget } from '../map-link';
import { BandFrame } from './BandFrame';
import { BandButtons } from './BandButtons';
import type { BandDef, BandProps } from './kind';

function Draw({ b, tinted }: BandProps) {
  return (
    <BandFrame tinted={tinted} heading={b.heading}>
      {b.address ? <address className="ev-address">{b.address}</address> : null}
      {b.bodyHtml ? <Html className="md-body lede">{b.bodyHtml}</Html> : null}
      {b.mapHref ? (
        <div className="btns">
          <a className="btn btn-ghost" href={b.mapHref} {...mapTarget(b.mapHref)}>{b.mapLabel || b.mapHref}</a>
        </div>
      ) : null}
      <BandButtons b={b} />
    </BandFrame>
  );
}

export const location: BandDef = { has: (b) => !!(b.address || b.mapHref), Draw };
